
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"128","height":"128","viewBox":"0 0 128 128","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M106.667 16H21.334c-5.883 0-10.667 4.784-10.667 10.667v64c0 5.882 4.784 10.666 10.667 10.666h16v20.091l33.477-20.091h35.856c5.883 0 10.667-4.784 10.667-10.666v-64c0-5.883-4.784-10.667-10.667-10.667zm0 74.667h-38.81L48 102.576v-11.91H21.334v-64h85.333v64z"}})])
          )
        }
      }
    